import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSpa = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSpa",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M474-83q-174-26-276-134T82-513q-1-11 3-19t9-15 15-9 18-1q183 25 282 141t110 290q1 9-2 18t-11 14q-6 6-14 10t-18 1m6-372q-14-22-64-64t-86-57q8-50 41-126t77-139q6-8 15-12t17-4 17 4 14 13q45 63 79 138t40 126q-39 18-87 59t-63 62m118 343q-2-61-18-138t-52-134q43-66 128-114t178-59q10-2 18 2t14 9 10 14 2 18q-8 161-87 262T598-112"
  })
}));
IconSpa.displayName = 'IconSpa';